import { TFunction } from "i18next";

export enum CpiModeEnum {
    MONTHLY = 'MONTHLY',
    ANNUAL_AVERAGE = 'ANNUAL_AVERAGE',
}

export const getCPIModeOptions = (t: TFunction) => {
  return Object.values(CpiModeEnum).map((value) => ({
    label: t(`analysisAndReports:${value}`), 
    value: value,
  }));
};